import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Grid, Typography, Radio, Collapse, FormControl,
  RadioGroup, FormControlLabel, Checkbox, Link, Button,
  Paper, CircularProgress, ListItem, ListItemText, List,
  Divider, ListItemSecondaryAction, MenuItem,
  Select, TextField, InputLabel,
} from "@material-ui/core";

import Cart from '../Cart.js';

import Alert from '@material-ui/lab/Alert'
import { withStyles } from "@material-ui/core/styles";
import Lock from "@material-ui/icons/Lock";

import * as PaymentActions from "../../actions/PaymentActions";
import { updateCartItems } from "../../actions/CartActions";
import StripeCheckoutForm from "../Stripe/StripeCheckoutForm";

import { CartItemTypes, FAIR_MARKET, WEBSITE_REDIRECT_URL, TVI_PHONE, GUARANTEED_TIME } from "../../constants";
import {
  createPayPalOrder, checkPayPalOrderCapture, createPayPalSubscription, checkPayPalSubscriptionCapture, hasCustomOfferWithSubscription,
  hasSubscription, extractCartItems, getTotalPricesStrArray, hasUnPaidProducts, hasUnPaidSubscriptions, hasProducts, openNewWindow,
  rebatePayInFull, fetchConversionRate, formatConversionAmount, createCrypoPayment, 
} from "../../utils";

const transactionType = {
  single: { type: 'single', done: false },
  subscription: { type: 'subscription', done: false },
}

var transactionOrder = [];

const styles = (theme) => ({
  listItemRoot: {
    width: "85%",
    paddingRight: "0",
    "& img": {
      width: "10em",
      height: "10em",
      margin: "auto",
      marginBottom: '5px'
    }
  },
  listItemAvatarRoot: {
    marginRight: "16px",
    minWidth: "unset",
  },
  paymentType: {
    backgroundColor: "unset !important"
  },
  removePaddingBottom: {
    paddingBottom: "0 !important"
  },
  removePaddingTop: {
    paddingTop: "0 !important"
  },
  payPalPayBtn: {
    margin: "0 0 10px 0",
    height: "3rem"
  },
  tcs: {
    // padding: "20px"
  },
  TC: {
    listStyleType: "none",
    padding: "0",
    margin: "0"
  },
  ssl: {
    display: "grid",
    gridTemplateColumns: "max-content 1fr",
    gridGap: "9px",
    paddingTop: "10px !important",
    paddingBottom: "10px !important"
  },
  paypal: {
    width: "4.8rem"
  },
  crypto: {
    width: "6.5rem"
  },
  BTCContainer: {
    display: "grid",
    width: "4em",
    textAlign: "center",
    gridTemplateRows: "max-content 1fr 1fr",
    "& img": {
      width: "2.5em",
      height: "2.5em",
      margin: "auto",
    }
  },
  ETHContainer: {
    display: "grid",
    width: "4em",
    textAlign: "center",
    "& img": {
      width: "2.5em",
      height: "2.5em",
      margin: "auto",
    }
  },
  cryptoLogoContainer: {
    display: "grid",
    gridTemplateColumns: "max-content max-content max-content max-content",
    gridTemplateRows: "max-content",
    gridGap: "25px",
    paddingBottom: "0 !important",
    paddingTop: "20px !important",
  },
  cardLogoContainer: {
    display: "grid",
    gridTemplateColumns: "max-content max-content max-content",
    gridTemplateRows: "max-content",
    gridGap: "25px",
    paddingBottom: "0 !important"
  },
  visaContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  masterContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  expressContainer: {
    display: "grid",
    gridTemplateRows: "max-content",
    placeContent: "center",
    "& img": {
      width: "2.8em",
    }
  },
});

const PPLabel = withStyles({
  root: {
    display: "grid"
  },
})(Typography);

class StepThree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreeOne: false,
      agreeTwo: false,
      agreeThree: false,

      payPalCaptureStatus: 'PENDING',
      payPalSubscriptionCaptureStatus: 'PENDING',

      showStripe: true,
      showCrypto: true,

      showCryptoQR: false,
      isLoadingRate: false,
      cryptoType: 'BTC',
      hashId: '',
      audToUsdRate: 0.6,
      cryptoToUsdRate: 50,
      rateCountDown: GUARANTEED_TIME,

      refresh: 0,
    };

    this.pageTimer = null;
    this.rateTimer = null;
    this.interval = null;
    this.payPalCheckoutWindow = null;
    this.togglePaymentType = this.togglePaymentType.bind(this);
    this.hasAgreed = this.hasAgreed.bind(this);
    this.checkPayPalCaptureStatus = this.checkPayPalCaptureStatus.bind(this);
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { payPalCaptureStatus, payPalSubscriptionCaptureStatus } = this.state;
    const { payPalCaptureStatus: prevPayPalCaptureStatus, payPalSubscriptionCaptureStatus: prevPayPalSubscriptionCaptureStatus } = prevState;
    
    const { paymentType, cart, step, actions } = this.props;
    const { paymentType: prevPaymentType, cart: prevCart, step: prevStep } = prevProps;


    if (step !== prevStep || paymentType !== prevPaymentType)  {
      this.setState({ agreeOne: false, agreeTwo: false, agreeThree: false });
    }

    if (cart.length !== prevCart.length) {
      this.updateTransactionOrder(cart);
      this.checkFairMarket(cart);
    }


    if (
      (prevPayPalCaptureStatus === 'PENDING' && payPalCaptureStatus !== 'PENDING') ||
      (prevPayPalSubscriptionCaptureStatus === 'PENDING' && payPalSubscriptionCaptureStatus !== 'PENDING')
    ) {

      if (payPalSubscriptionCaptureStatus === 'FAILED' || payPalCaptureStatus === 'FAILED') {
        if (this.payPalCheckoutWindow) this.payPalCheckoutWindow.close();
        actions.setOverlay(false);
      } else {
        if (transactionOrder[1] && !transactionOrder[1].done) this.handlePayPalPayment(transactionOrder[1].type);
        else {
          if (this.payPalCheckoutWindow) this.payPalCheckoutWindow.close();
          actions.setOverlay(false);
        }
      }
    }

    if (prevPayPalCaptureStatus === 'PENDING' && payPalCaptureStatus === 'COMPLETED') {
      this.updateCartItemsToPaid('single');
      if (transactionOrder.every(({ done }) => done)) {
        actions.openSnackbar('success', 'You will now be redirected to the website');
        setTimeout(() => window.location.replace(WEBSITE_REDIRECT_URL), 2000);
      }
    } else if (prevPayPalCaptureStatus === 'PENDING' && payPalCaptureStatus === 'FAILED') {
      actions.openSnackbar('error', 'Payment Failed');
    }
    
    if (prevPayPalSubscriptionCaptureStatus === 'PENDING' && payPalSubscriptionCaptureStatus === 'COMPLETED') {
      this.updateCartItemsToPaid('subscription');
      if (transactionOrder.every(({ done }) => done)) {
        actions.openSnackbar('success', 'You will now be redirected to the website');
        setTimeout(() => window.location.replace(WEBSITE_REDIRECT_URL), 2000);
      }
    } else if (prevPayPalSubscriptionCaptureStatus === 'PENDING' && payPalSubscriptionCaptureStatus === 'FAILED') {
      actions.openSnackbar('error', 'Payment Failed');
    }
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  checkPayPalCaptureStatus = async (token) => {
    const { ok, tokenStatus } = await checkPayPalOrderCapture(token);
    if (ok) {
      const transOrderIndex = transactionOrder.findIndex(({ type }) => type === 'single');
  
      if (tokenStatus === 'COMPLETED') transactionOrder[transOrderIndex].done = true;
  
      this.setState({ payPalCaptureStatus: tokenStatus });

    } else this.setState({ payPalCaptureStatus: 'FAILED' });
  }
  
  checkPayPalSubscriptionCaptureStatus = async (subscriptionId) => {
    const { ok, subscriptionIdStatus } = await checkPayPalSubscriptionCapture(subscriptionId);

    if (ok) {
      const transOrderIndex = transactionOrder.findIndex(({ type }) => type === 'subscription');
  
      if (subscriptionIdStatus === 'COMPLETED') transactionOrder[transOrderIndex].done = true;
      
      this.setState({ payPalSubscriptionCaptureStatus: subscriptionIdStatus });
    } else this.setState({ payPalSubscriptionCaptureStatus: 'FAILED' });
  }

  startTimer = () => {
    this.clearTimer();
    this.rateTimer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.rateCountDown > 0) {
          return { rateCountDown: prevState.rateCountDown - 1 };
        } else {
          this.handleCryptoConversionShow();
          return { rateCountDown: GUARANTEED_TIME };
        }
      });
    }, 1000);
  };

  clearTimer = () => {
    if (this.rateTimer) {
      clearInterval(this.rateTimer);
      this.rateTimer = null;
    }
  };

  resetTimer = () => {
    this.setState({ rateCountDown: GUARANTEED_TIME });
    this.startTimer();
  };

  hasAgreed = () => {
    const { agreeOne, agreeTwo, agreeThree } = this.state;
    const hasSubs = hasSubscription(this.props.cart) || hasCustomOfferWithSubscription(this.props.cart);
    const hasProd = hasProducts(this.props.cart);

    if (hasSubs && hasProd) return  agreeOne === true && agreeTwo === true && agreeThree === true;
    else if(hasSubs) return  agreeOne === true && agreeThree === true;
    else return agreeOne === true && agreeTwo === true;
  }

  handleCrypoPaymentCreation = async(amount) => {
    const { actions, orderId, userId, } = this.props;
    const { audToUsdRate, cryptoToUsdRate, hashId, cryptoType } = this.state;
    if (!orderId || !userId || !Number(amount) || !Number(audToUsdRate) || !Number(cryptoToUsdRate)) {
      return actions.openSnackbar('error', `Something went wrong. Please contact us at ${TVI_PHONE}`);
    }

    if (!hashId || hashId === '' || hashId.length < 10) {
      return actions.openSnackbar('error', `Please enter valid hash code`);
    }

    const amountUSD = formatConversionAmount(amount * audToUsdRate, 5);
    const cryptoAmount = formatConversionAmount(amount * audToUsdRate / cryptoToUsdRate, 5);

    const object = {
      orderId, userId, hashId, amount, 
      amountUSD, cryptoAmount, cryptoType,
      audToUsdRate: formatConversionAmount(audToUsdRate, 5),
      cryptoToUsdRate: formatConversionAmount(cryptoToUsdRate, 2),
    }

    this.setState({ loading: true });


    try {
      const { ok, msg } = await createCrypoPayment(object);
      if (ok) {
        actions.openSnackbar('success', 'Your crypto payment will be reviewed and processed soon');
        setTimeout(() => window.location.replace(WEBSITE_REDIRECT_URL), 2000);
      } else {
        let errorMessage = msg ? msg : `Something went wrong. Please contact us at ${TVI_PHONE}`;
        actions.openSnackbar('error', errorMessage);
      }

    } catch (error) {
      console.error(error);
      let errorMessage = `Something went wrong. Please contact us at ${TVI_PHONE}`;
      if (error.msg) errorMessage = error.msg;
      actions.openSnackbar('error', errorMessage);
    } finally {
      actions.setLoading(false);
    }
  }

  handleCryptoConversionShow = async(reset) => {
    const { state, props } = this;
    const { actions } = props;
    const { cryptoType } = state;
    this.setState({ showCryptoQR: true, isLoadingRate: true });
    let type = cryptoType;
    if (cryptoType === '') {
      this.setState({ cryptoType: 'BTC' });
      type = 'BTC';
    }
    const [audToUsdRate, cryptoToUsdRate] = await fetchConversionRate(type);

    if (!audToUsdRate || !cryptoToUsdRate || !Number(cryptoToUsdRate) || !Number(audToUsdRate)) {
      actions.openSnackbar('error', 'Unable to fetch conversion rate, please try it again later');
      this.setState({ isLoadingRate: false });
      return;
    }

    if (!this.rateTimer) this.startTimer();
    if (reset) this.resetTimer();

    this.setState({
      audToUsdRate, 
      cryptoToUsdRate,
      isLoadingRate: false,
    })
  }

  handleCryptoTypeChange = (newValue) => {
    this.setState({ cryptoType: newValue }, () => {
      this.resetTimer();
      this.handleCryptoConversionShow(true);
    })
  }

  togglePaymentType = ({ target }) => {
    this.setState({ showCryptoQR: false });
    this.clearTimer();
    this.props.actions.setPaymentType(Number(target.value));
  }

  updateCartItemsToPaid = (type) => {
    const { cart, onUpdateCartItems } = this.props;
    let newCartItems;

    if (type === 'single') newCartItems = cart.map(({ _id, type, paidFor, ...rest }) => type !== CartItemTypes.subscriptionPlan ? ({...rest, _id, type, paidFor: [ ...paidFor, _id ] }) : ({ ...rest, _id, type, paidFor }));
    else if (type === 'subscription') newCartItems = cart.map((i) => {
      if (i.type === CartItemTypes.subscriptionPlan) {
        return ({ ...i, paidFor: [ ...i.paidFor, i._id ] });
      } else if (i.type === CartItemTypes.customOffer) {
        let newPaidFor = i.paidFor;
        i.items.forEach(it => {
          if (it.type === CartItemTypes.subscriptionPlan) {
            newPaidFor.push(it._id);
          }
        });

        return ({ ...i, paidFor: newPaidFor });

      } else return i;
    });

    onUpdateCartItems(newCartItems);
  }

  checkFairMarket = (cart = []) => {
    const fairMarketsIndex = cart.findIndex(({ _id }) => _id === FAIR_MARKET);
    if (fairMarketsIndex !== -1) {
      this.togglePaymentType({ target: {value: 0} });
      this.setState({ showStripe: false });
    } else {
      this.setState({ showStripe: true });
    }
  }

  updateTransactionOrder = (cart = []) => {
    const [ subs, products, customOfferSubs ] = extractCartItems(cart);
    let newTransactionOrder = [];
    const subTotal = subs.reduce((total, { price, paidFor, _id }) => !paidFor.includes(_id) ? total + price : total, 0);
    const customOfferSubsTotal = customOfferSubs.reduce((total, { price, paidFor, _id }) => !paidFor.includes(_id) ? total + price : total, 0); // TODO: make sure custom offer sub is not paid for;
    const productTotal = products.reduce((total, { price, paidFor, _id }) => !paidFor.includes(_id) ? total + price : total, 0);
    let subscriptionTotal = 0;

    if (subTotal !== 0 || customOfferSubsTotal !== 0) {
      if (subTotal > customOfferSubsTotal) subscriptionTotal = subTotal;
      else subscriptionTotal = customOfferSubsTotal;
    }

    if (subscriptionTotal === 0 && productTotal !== 0) newTransactionOrder = [ transactionType.single ];
    else if (subscriptionTotal !== 0 && productTotal === 0) newTransactionOrder = [ transactionType.subscription ];
    else if (subscriptionTotal !== 0 && productTotal !== 0) {
      if (subscriptionTotal > productTotal) newTransactionOrder = [ transactionType.subscription, transactionType.single ];
      else newTransactionOrder = [ transactionType.single, transactionType.subscription ];
    }

    if (hasCustomOfferWithSubscription(cart)) {
      const subsIndex = newTransactionOrder.findIndex(({ type }) => type === 'subscription');

      if (subsIndex === 0) {
        const temp = newTransactionOrder[0];
        newTransactionOrder[0] = newTransactionOrder[1]
        newTransactionOrder[1] = temp;
      }
    }

    transactionOrder = newTransactionOrder;
  }

  isConsultingServicesProdValid = () => true

  handlePayPalSubscriptionPayment = async () => {
    const { actions } = this.props;
    if (!this.hasAgreed())
      return actions.openSnackbar('error', 'Please agree to the Terms & Conditions.');

    actions.setLoading(true);

    try {
      const { payPalSubscription } = await createPayPalSubscription();

      if (payPalSubscription && Array.isArray(payPalSubscription.links) && payPalSubscription.status === 'APPROVAL_PENDING') {
        const popUpLink = payPalSubscription.links.find(({ rel }) => rel === 'approve');
        if (popUpLink) {
          if (this.payPalCheckoutWindow) {
            actions.setOverlay(true);
            this.payPalCheckoutWindow.location = popUpLink.href;
            this.checkPayPalSubscriptionCaptureStatus(payPalSubscription.id);

          } else throw new Error('_Failed to open PayPal');
        } else actions.openSnackbar('error', `Something went wrong. Please contact us at ${TVI_PHONE}`);
      } else actions.openSnackbar('error', `Something went wrong. Please contact us at ${TVI_PHONE}`);

    } catch (error) {
      console.error(error)
      actions.setOverlay(false);
      let errorMessage = `Something went wrong. Please contact us at ${TVI_PHONE}`;
      if (error.message && error.message.startsWith('_')) errorMessage = error.message.slice(1);
      actions.openSnackbar('error', errorMessage);
      if (this.payPalCheckoutWindow) this.payPalCheckoutWindow.close();
    } finally {
      actions.setLoading(false);
    }
  }

  handlePayPalSinglePayment = async () => {
    const { actions } = this.props;

    try {
      const { payPalOrder } = await createPayPalOrder();

      if (payPalOrder && Array.isArray(payPalOrder.links) && payPalOrder.status === 'CREATED') {
        const popUpLink = payPalOrder.links.find(({ rel }) => rel === 'approve');
        if (popUpLink) {
          if (this.payPalCheckoutWindow) {
            this.payPalCheckoutWindow.location = popUpLink.href;
            actions.setOverlay(true);
            this.checkPayPalCaptureStatus(payPalOrder.id);
          } else throw new Error('_Failed to open PayPal');
        } else throw new Error('Approve link is missing');
      } else throw new Error('PayPal order creation failed');

    } catch (error) {
      console.error(error);
      actions.setOverlay(false);
      let errorMessage = `Something went wrong. Please contact us at ${TVI_PHONE}`;
      if (error.message && error.message.startsWith('_')) errorMessage = error.message.slice(1);
      actions.openSnackbar('error', errorMessage);
      if (this.payPalCheckoutWindow) this.payPalCheckoutWindow.close();
    } finally {
      actions.setLoading(false);
    }
  }

  handlePayPalPayment = (type) => {
    const { actions } = this.props;
    if (!this.hasAgreed())
      return actions.openSnackbar('error', 'Please agree to the Terms & Conditions.');

    try {
      const result = openNewWindow();

      if (result && result.error) throw new Error(result.error);
      else this.payPalCheckoutWindow = result;

      actions.setLoading(true);

      if (type === 'single') this.handlePayPalSinglePayment();
      else if (type === 'subscription') this.handlePayPalSubscriptionPayment();
      else actions.openSnackbar('error', `Something went wrong. Please contact us at ${TVI_PHONE}`);
    } catch (error) {
      console.error(error);
      actions.setLoading(false);
      let errorMessage = `Something went wrong. Please contact us at ${TVI_PHONE}`;
      if (error.message && error.message.startsWith('_')) errorMessage = error.message.slice(1);
      actions.openSnackbar('error', errorMessage);
    }
  }

  handleRebatePayment = async (hasAgreed) => {
    const { actions, orderId } = this.props;
    if (!hasAgreed) return actions.openSnackbar('error', 'Please agree to the Terms & Conditions.');
    actions.setLoading(true);
    try {
      const { ok, msg } = await rebatePayInFull(orderId);
      if (ok) {
        actions.openSnackbar('success', 'You will now be redirected to the website');
        setTimeout(() => window.location.replace(WEBSITE_REDIRECT_URL), 2000);
      } else {
        let errorMessage = msg ? msg : `Something went wrong. Please contact us at ${TVI_PHONE}`;
        actions.openSnackbar('error', errorMessage);
      }

    } catch (error) {
      console.error(error);
      let errorMessage = `Something went wrong. Please contact us at ${TVI_PHONE}`;
      if (error.msg) errorMessage = error.msg;
      actions.openSnackbar('error', errorMessage);
    } finally {
      actions.setLoading(false);
    }

  }

  renderCardLogos = (pureBalancePayment) => {
    const { classes } = this.props;
    if (pureBalancePayment) return null
    return (<>
      <div className={classes.visaContainer}>
        <img src="/media/visa.svg" alt="visa-logo"/>
      </div>
      <div className={classes.masterContainer}>
        <img src="/media/master.svg" alt="master-logo"/>
      </div>
      <div className={classes.expressContainer}>
        <img src="/media/amex.svg" alt="express-logo"/>
      </div>
    </>);
  }

  renderCryptoLogos = (pureBalancePayment) => {
    if (pureBalancePayment) return null
    const { classes } = this.props;
    return (<>
      <div className={classes.BTCContainer}>
        <img src="/media/BTC-logo.svg" alt="btc-logo"/>
        <span>BTC</span>
      </div>
      <div className={classes.ETHContainer}>
        <img src="/media/ETH-logo.svg" alt="eth-logo"/>
        <span>ETH</span>
        <span>(ERC20)</span>
      </div>
      {/* <div className={classes.ETHContainer}>
        <img src="/media/USDT-logo.svg" alt="usdt-logo"/>
        <span>USDT</span>
        <span>(ERC20)</span>
      </div>
      <div className={classes.ETHContainer}>
        <img src="/media/USDT-logo.svg" alt="usdt-logo"/>
        <span>USDT</span>
        <span>(TRC20)</span>
      </div> */}
    </>);
  }

  renderTermsAndConditions = () => {
    const { classes } = this.props;
    return (<>
      <Grid item xs={12} style={{ paddingBottom: "0" }}>
        <Typography variant="h6"><strong>Terms &amp; Conditions</strong></Typography>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: "7px" }}>
        <Paper variant="outlined" className={classes.tcs} >
          <ul className={classes.TC}>
            <li>• I understand the agreement I am entering into with Trade View.</li>
            <li>• I understand that some products discussed in the development programs &amp; software are leveraged derivative products and carry a high level of risk to my capital.</li>
            <li>• I understand that I should only risk capital that I can afford to lose. In certain circumstances due to fluctuations in value I may not get back my initial investment amount.</li>
            <li>• I understand that I may not only lose my initial investment but I may also incur a liability to pay a further amount.</li>
            <li>• I understand that leveraged products are only suitable for investors who understand the risks associated with such products and may not be suitable for all investors.</li>
            <li>• I understand that further information relating to the risks associated with Leveraged products are outlined in the Product Disclosure Statement of the product provider.</li>
            <li>• I agree to read and understand this document (Product Disclosure Statement) prior to opening an account with the product provider.</li>
            <li>• I understand that Trade View makes no claim or assurances that I will become a profitable trader once I have completed  the development programs or by using the software .</li>
            <li>• I understand that the  development programs &amp; software are designed to provide me with tools to trade the markets and then I will need to commit extra time and effort into my trading if I desire a specific result which cannot and will not be guaranteed by Trade View.</li>
            <li>• I understand that I may need additional mentoring at a further cost to me if my specific desired result is not achieved once completing the development programs or by using the software.</li>
            <li>• I have been provided the following documents via the website: <Link href="https://www.tradeview.com.au/terms-conditions/" target="_blank">Terms and Conditions</Link>, <Link href="https://www.tradeview.com.au/privacy-policy/" target="_blank">Privacy Policy</Link>, <Link href="https://www.tradeview.com.au/disclaimer/" target="_blank">Disclaimer</Link>, <Link href="https://www.tradeview.com.au/financial-services-guide/?_ga=2.215575826.440151372.1594595168-1439122008.1594595168" target="_blank">Financial Services Guide</Link></li>
          </ul>
        </Paper>
      </Grid>
    </>);
  }

  renderCartList = () => {
    const { cart, classes } = this.props;
    const cartItems = cart || [];

    if (cartItems.length <= 0) return (
      <ListItem>
        <ListItemText primary="Cart Empty" primaryTypographyProps={{ variant: "h6", noWrap: true, style: { textAlign: "center" } }} />
      </ListItem>
    );

    return (
      <>
        <Grid item xs={12} style={{ paddingBottom: "0" }}>
          <Typography variant="h6"><strong>Shopping Cart</strong></Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "7px" }}>
          <Paper variant="outlined" className={classes.tcs} >
            <Cart  pageView={true} />
          </Paper>
      </Grid>
      </>
    )
  }

  renderPayPalButtons = () => {
    const { payPalCaptureStatus, payPalSubscriptionCaptureStatus } = this.state;
    const { classes, loading, cart, actions } = this.props;

    const onClick = () => {
      const { cart, coupon, installments, rebate, balance, depositUsed, creditUsed } = this.props;
      const installment = installments.find(({ paid }) => !paid);
      const [ productTotalStr, customOfferSubsTotalStr, subsTotalStr ] = getTotalPricesStrArray(cart, coupon, installment, rebate, balance, depositUsed, creditUsed);

      if (productTotalStr === '$0 ' && customOfferSubsTotalStr === '' && subsTotalStr === '' ) {
        this.handleRebatePayment(this.hasAgreed());
      } else {
        if ( payPalCaptureStatus !== 'PENDING' || payPalSubscriptionCaptureStatus !== 'PENDING')
          this.setState({ payPalCaptureStatus: 'PENDING', payPalSubscriptionCaptureStatus: 'PENDING' });

        if (!hasUnPaidSubscriptions(cart) && !hasUnPaidProducts(cart))
          return actions.openSnackbar('warning', 'All items have been paid for');
      
        const transOrder = transactionOrder.find(({ done }) => !done);

        if (!transOrder) 
          return actions.openSnackbar('error', 'Something went wrong. Please refresh and try again');
        else {
          this.handlePayPalPayment(transOrder.type);
        }
      }
    }

    return (
      <Button id="pay-pal-pay-button" className={classes.payPalPayBtn} variant="contained" color="primary" fullWidth onClick={onClick} disabled={loading || cart.length === 0}>
        {loading ? <Typography variant="h5"> <CircularProgress size={20} />&nbsp;Please Wait...</Typography> : <Typography variant="h5">Pay Now</Typography>}
      </Button>
    );
  }

  renderCryptoButtons = () => {
    const { classes, loading, cart, actions } = this.props;

    const onClick = () => {
      const { cart, coupon, installments, rebate, balance, depositUsed, creditUsed } = this.props;
      const { showCryptoQR } = this.state;
      const installment = installments.find(({ paid }) => !paid);
      const [ productTotalStr, customOfferSubsTotalStr, subsTotalStr, thisPaymentAmount ] = getTotalPricesStrArray(cart, coupon, installment, rebate, balance, depositUsed, creditUsed);

      if (productTotalStr === '$0 ' && customOfferSubsTotalStr === '' && subsTotalStr === '' ) {
        this.handleRebatePayment(this.hasAgreed());
      } else if (hasUnPaidSubscriptions(cart)) {
        return actions.openSnackbar('error', 'Crypto Payment does not support subscription plan at the moment');
      } else if (thisPaymentAmount < 1) {
        return actions.openSnackbar('error', 'Crypto Payment only support AUD 1 and above amount');
      } else {
        if (showCryptoQR) {
          this.handleCrypoPaymentCreation(thisPaymentAmount);
        } else {
          this.handleCryptoConversionShow();
        }
      }
    }

    return (
      <Button id="pay-pal-pay-button" className={classes.payPalPayBtn} variant="contained" color="primary" fullWidth onClick={onClick} disabled={loading || cart.length === 0}>
        {loading ? <Typography variant="h5"> <CircularProgress size={20} />&nbsp;Please Wait...</Typography> : <Typography variant="h5">Pay Now</Typography>}
      </Button>
    );
  }

  renderPayPalCheckboxes = () => {
    const { state, props } = this;
    const { agreeOne, agreeTwo, agreeThree, showCryptoQR } = state;
    const { cart, coupon, installments, rebate, balance, depositUsed, creditUsed } = props;
    const installment = installments.find(({ paid }) => !paid);
    const content = [];
    const [ productTotalStr, customOfferSubsTotalStr, subsTotalStr ] = getTotalPricesStrArray(cart, coupon, installment, rebate, balance, depositUsed, creditUsed);

    if (hasUnPaidProducts(cart)) {
      content.push(
        <FormControlLabel key='0'
          control={<Checkbox color="primary" checked={agreeTwo} onChange={(event) => this.setState({ agreeTwo: event.target.checked })} name="agreeTwo" disabled={showCryptoQR && agreeTwo}/>}
          label={<Typography variant="body2">I understand that <strong>{productTotalStr.replace(' +', '')}</strong> is a one off payment.</Typography>}
        />
      )
    }

    if (hasUnPaidSubscriptions(cart)) {
      let subscriptionPriceStr;
      if (subsTotalStr.length > 0) subscriptionPriceStr = subsTotalStr;
      else if (customOfferSubsTotalStr.length > 0) subscriptionPriceStr = customOfferSubsTotalStr;

      let paymentMehod = 'is a recurring payment';
      if (subscriptionPriceStr === '$165 - 3 month access') {
        paymentMehod = 'is a one off payment'
      }
  
      content.push(
        <FormControlLabel key='1'
          control={<Checkbox color="primary" checked={agreeThree} onChange={({ target }) => this.setState({ agreeThree: target.checked })} name="agreeThree" disabled={showCryptoQR && agreeThree} />}
          label={<Typography variant="body2">I understand that <strong>{subscriptionPriceStr}</strong> {paymentMehod}.</Typography>}
        />
      );
    }

    return (<>
      <Grid item xs={12}>
        <Grid container  direction="column" justify="flex-start" alignItems="stretch">
          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeOne} onChange={({ target }) => this.setState({ agreeOne: target.checked })} name="agreeOne" disabled={showCryptoQR && agreeOne} />}
            label={<Typography variant="body2">I hereby confirm that I have read, understand and agree to be bound by the terms of these documents. <Link href="https://www.tradeview.com.au/terms-conditions/" target="_blank">Terms and Conditions</Link>, <Link href="https://www.tradeview.com.au/privacy-policy/" target="_blank">Privacy Policy</Link>, <Link href="https://www.tradeview.com.au/disclaimer/" target="_blank">Disclaimer</Link>, <Link href="https://www.tradeview.com.au/financial-services-guide/?_ga=2.215575826.440151372.1594595168-1439122008.1594595168" target="_blank">Financial Services Guide</Link></Typography>}
          />

          {content}
        </Grid>
      </Grid>
    </>);
  }

  renderCryptoExchangeContent = () => {
    const { state } = this;
    const { classes, cart, coupon, installments, rebate, balance, depositUsed, creditUsed } = this.props;
    const { isLoadingRate, cryptoType, rateCountDown, audToUsdRate, cryptoToUsdRate, hashId } = state;

    const installment = installments.find(({ paid }) => !paid);
    const [ productTotalStr, customOfferSubsTotalStr, subsTotalStr, thisPaymentAmount ] = getTotalPricesStrArray(cart, coupon, installment, rebate, balance, depositUsed, creditUsed);

    if (isLoadingRate) return (
      <ListItem style={{ display: 'grid', gridTemplateColumns: "max-content", placeContent: 'center' }}>
        <CircularProgress size={40} />
      </ListItem>
    );

    const imageSrc = `/media/${cryptoType.toLowerCase()}_qr_code.svg`;

    return (
      <>
        <div key={'crypto-type'}>
          <ListItem classes={{ root: classes.listItemRoot }}>
            <ListItemText
              primary={'Crypto Type'}
              secondary={'Select crypto that you would like to pay'}
              primaryTypographyProps={{ variant: "body1", noWrap: true }}
              secondaryTypographyProps={{ variant: "subtitle2", noWrap: true }}
            />
            <ListItemSecondaryAction>
              {/* <Typography variant="body2"> */}
              <FormControl variant="filled">
              <InputLabel htmlFor="outlined-age-native-simple"></InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                variant="outlined" 
                value={cryptoType}
                onChange={({target}) => this.handleCryptoTypeChange(target.value)}
              >
                <MenuItem value={'BTC'}>BTC</MenuItem>
                <MenuItem value={'ETH'}>ETH</MenuItem>
                {/* <MenuItem value={'USDT(ERC20)'}>USDT(ERC20)</MenuItem>
                <MenuItem value={'USDT(TRC20)'}>USDT(TRC20)</MenuItem> */}
              </Select>
              {/* </Typography> */}
              </FormControl>
            </ListItemSecondaryAction>
          </ListItem>
        </div>

        <Divider orientation="horizontal" />

        <div key={'crypto-rate'}>
          <ListItem classes={{ root: classes.listItemRoot }}>
            <ListItemText
              primary={'Guaranteed Rate'}
              secondary={`00:${rateCountDown < 10 ? `0${rateCountDown}` : rateCountDown}`}
              primaryTypographyProps={{ variant: "body1", noWrap: true }}
              secondaryTypographyProps={{ variant: "subtitle2", noWrap: true }}
            />
            <ListItemSecondaryAction>
              <Typography variant="body2">{audToUsdRate === 0 || cryptoToUsdRate === 0 ? 'loading' : formatConversionAmount(cryptoToUsdRate, 2)}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
        </div>

        <Divider orientation="horizontal" />

        <div key={'amount-in-aud'}>
          <ListItem classes={{ root: classes.listItemRoot }}>
            <ListItemText
              primary={'Amount'}
              secondary={'AUD'}
              primaryTypographyProps={{ variant: "body1", noWrap: true }}
              secondaryTypographyProps={{ variant: "subtitle2", noWrap: true }}
            />
            <ListItemSecondaryAction>
              <Typography variant="body2">{thisPaymentAmount}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
        </div>

        <Divider orientation="horizontal" />
        
        <div key={'amount-in-crypto'}>
          <ListItem classes={{ root: classes.listItemRoot }}>
            <ListItemText
              primary={'Amount'} 
              secondary={'Crypto'}
              primaryTypographyProps={{ variant: "body1", noWrap: true }}
              secondaryTypographyProps={{ variant: "subtitle2", noWrap: true }}
            />
            <ListItemSecondaryAction>
              <Typography variant="body2">{audToUsdRate === 0 || cryptoToUsdRate === 0 ? 'loading' : formatConversionAmount(thisPaymentAmount * audToUsdRate / cryptoToUsdRate, 5)}</Typography>
            </ListItemSecondaryAction>
          </ListItem>
        </div>

        <Divider orientation="horizontal" />

        <div>
          <ListItem classes={{ root: classes.listItemRoot }}>
            <img src={imageSrc} alt="payment-qr-code"/>
          </ListItem>
        </div>

        <Divider orientation="horizontal" />

        <TextField
          required
          id="hashId"
          name="hashId"
          type="string"
          defaultValue={hashId || ''}
          onBlur={(e) => this.setState({ hashId: e.target.value})}
          label={'Hash code'}
          error={hashId.length < 10 && hashId !== ''}
          helperText={'Please enter valid hash code when payment completed'}
          fullWidth={true}
          variant="outlined"
        />
      </>
    )
  }

  renderCryptoExchangeSection = () => {
    const { props } = this;
    const { classes } = props;

    return(
      <Paper variant="outlined" className={classes.tcs} >
        <Grid container spacing={2}>
          <Grid item xs={12} style={{ paddingTop: "20px" }}>
            <List dense={true}>
              {this.renderCryptoExchangeContent()}
            </List>
          </Grid>
        </Grid>
      </Paper>
    )
  }

  renderPayPalCheckout = (pureBalancePayment) => {
    const { renderCardLogos, props } = this;
    const { classes } = props;

    return (<Grid container spacing={2}>
      <Grid item xs={12} style={{ paddingTop: "20px" }}>
        <Grid item xs={12} className={classes.cardLogoContainer}>{renderCardLogos(pureBalancePayment)}</Grid>
        {/* <Grid container spacing={2}>{this.renderTermsAndConditions()}</Grid> */}
        
        <Grid container spacing={2}>{this.renderCartList()}</Grid>
      </Grid>

      {this.renderPayPalCheckboxes()}

      <Grid item xs={12}>{
        this.renderPayPalButtons()
      }</Grid>
    </Grid>)
  }

  renderStripeCheckout = (pureBalancePayment) => {
    const { props, generateUserDetails, isConsultingServicesProdValid, renderTermsAndConditions, renderCartList, updateCartItemsToPaid, handleRebatePayment } = this;
    const { paymentType, cart, installments, coupon, rebate, balance } = props;

    return (
      <StripeCheckoutForm {...{
        paymentType,
        generateUserDetails,
        isConsultingServicesProdValid,
        renderTermsAndConditions,
        renderCartList,
        updateCartItemsToPaid,
        cart,
        installments,
        coupon,
        rebate,
        handleRebatePayment,
        balance,
        pureBalancePayment
      }} />
    );
  }

  renderCryptoCheckout = (pureBalancePayment) => {
    const { state } = this;
    const { showCryptoQR } = state;

    return(
      <Grid container spacing={2}>
        <Grid item xs={12} className={this.props.classes.cryptoLogoContainer}>{this.renderCryptoLogos(pureBalancePayment)}</Grid>
        {/* <Grid item xs={12} className={classes.ssl}>
          <Lock style={{ color: "black" }} fontSize="small"/> <Typography style={{ color: "black" }} variant="body2"><strong>Secured by Crypto.com</strong></Typography>
        </Grid> */}
        <Grid item xs={12} style={{ paddingTop: "20px" }}>
          <Grid container spacing={2}>{this.renderCartList()}</Grid>
        </Grid>
        { this.renderPayPalCheckboxes() }
        <Grid item xs={12}>
          { showCryptoQR && this.renderCryptoExchangeSection() }
          { this.renderCryptoButtons() }
        </Grid>
      </Grid>
    )
  }

  render = () => {
    const { props, state } = this;
    const { loading, classes, cart, paymentType, balance, coupon, installment, rebate, depositUsed, creditUsed } = props;
    const { showStripe, showCrypto } = state;

    const [ productTotalStr, customOfferSubsTotalStr, subsTotalStr ] = getTotalPricesStrArray(cart, coupon, installment, rebate, balance, depositUsed, creditUsed);
    const pureBalancePayment = (balance > 0 || rebate > 0) && productTotalStr === '$0 ';
    return (
      <Grid container id='CardBrandIcon-container'>
        { pureBalancePayment ? null : 
        <>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom><strong>Select Payment Method</strong></Typography>
            {cart.length === 0 && !loading ? <Alert variant="outlined" severity="warning">Please add product(s) to your cart.</Alert> : null}
          </Grid>
        </>}
        
        <Grid item xs={12}>
          <Grid container spacing={2}>
            { pureBalancePayment ? null : 
            <Grid item xs={12} className={classes.removePaddingBottom}>
              <FormControl component="fieldset" className={classes.paymentType}>
                <RadioGroup row value={paymentType} onChange={this.togglePaymentType}>
                  <FormControlLabel value={0} control={<Radio id="tvi-radio-paypal" color="primary" />} label={<PPLabel><img className={classes.paypal} src="/media/paypal.svg" alt="PayPal Logo" /></PPLabel>} />
                  { showStripe && <FormControlLabel value={1} control={<Radio id="tvi-radio-stripe" color="primary" />} label={<Typography variant="h6">Credit or Debit Card</Typography>} /> }
                  { showCrypto && <FormControlLabel value={2} control={<Radio id="tvi-radio-stripe" color="primary" />} label={<Typography variant="h6">Crypto</Typography>} /> }
                </RadioGroup>
              </FormControl>
            </Grid>
            }
            
            <Grid item xs={12} className={classes.removePaddingTop}>
              <Collapse in={paymentType === 0}>{this.renderPayPalCheckout(pureBalancePayment)}</Collapse>
              <Collapse in={paymentType === 1}>{this.renderStripeCheckout(pureBalancePayment)}</Collapse>
              <Collapse in={paymentType === 2}>{this.renderCryptoCheckout(pureBalancePayment)}</Collapse>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
}

StepThree.propTypes = {};

const mapStateToProps = ({ payment, cartReducer, accountReducer }) => ({
  loading: payment.loading,
  step: payment.step,
  countries: payment.countries,
  discount: payment.discount,
  hasRecurringProduct: payment.hasRecurringProduct,
  userDetails: payment.userDetails,
  paymentType: payment.paymentType,
  cart: cartReducer.cart,
  paymentPlanValue: cartReducer.paymentPlanValue,
  coupon: cartReducer.coupon,
  installments: cartReducer.installments,
  rebate: cartReducer.rebate,
  balance: cartReducer.balance,
  orderId: cartReducer.orderId,
  depositUsed: cartReducer.depositUsed,
  creditUsed: cartReducer.creditUsed,
  userId: accountReducer._id,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
  onUpdateCartItems: (items) => dispatch(updateCartItems(items))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(StepThree));
